export default "__VITE_ASSET__FPAD7SOs__"